import styled from "styled-components";

export const InputDateBox = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
